import {register} from "../../../JavaScript/Utils";
import {updateBlogPagination} from "../../../JavaScript/BlogPaginationHelper";

export const BlogListingAjax = async (el: HTMLElement) => {

  const type: string = "1683867644";
  let fetchController: AbortController | null, signal: AbortSignal | null = null;
  const blogListingContainer = el.querySelector(".comp-blog-listing-item-container") as HTMLElement | null;
  const pagination = el.querySelector(".blogpagination-list") as HTMLElement | null;
  const paginationLinks = el.querySelectorAll('.blogpagination-link:not([rel="prev"]):not([rel="next"])');
  let currentPage: HTMLLinkElement = el.querySelector('.blogpagination-item--active').firstElementChild as HTMLLinkElement;
  const firstPage: HTMLLinkElement = el.querySelector('.blogpagination-item.first-page').firstElementChild as HTMLLinkElement;
  const lastPage: HTMLLinkElement = el.querySelector('.blogpagination-item.last-page').firstElementChild as HTMLLinkElement;
  const nextButton: HTMLLinkElement = el.querySelector('.blogpagination-item--next').firstElementChild as HTMLLinkElement;
  const previousButton: HTMLLinkElement = el.querySelector('.blogpagination-item--previous').firstElementChild as HTMLLinkElement;

  const startLoading = () => {
    blogListingContainer.classList.add("loading");
  };

  const endLoading = () => {
    blogListingContainer.classList.remove("loading");
    const yOffset = -150;
    const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
  };

  const initAbortController = () => {
    if (fetchController instanceof AbortController) {
      fetchController.abort();
    }

    fetchController = new AbortController();
    signal = fetchController.signal;
  }

  /**
   * @param direction true = next, false = previous
   */
  const changePage = (direction: boolean) => {

    let newPage = null;

    if (direction && currentPage !== lastPage) {
      newPage = currentPage.parentElement.nextElementSibling.firstElementChild as HTMLLinkElement;
    } else if (direction && currentPage === lastPage) {
      newPage = firstPage;
    } else if (!direction && currentPage !== firstPage) {
      newPage = currentPage.parentElement.previousElementSibling.firstElementChild as HTMLLinkElement;
    } else if (!direction && currentPage === firstPage) {
      newPage = lastPage;
    }

    if (newPage !== null) {
      loadPage(newPage);
    }

  }

  const loadPage = async (link: HTMLLinkElement) => {
    initAbortController();

    const href = link.href;

    try {

      startLoading();

      if (pagination) {
        updateBlogPagination(link, pagination);
        currentPage = link;
      }

      if (window.history.replaceState) {
        window.history.replaceState(new Date(), document.title, href);
      }

      const response: Response = await fetch(`${href}?type=${type}`, {signal});

      if (!response.ok) {
        console.log("error", response.ok);
        return;
      }

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      const responseHTML = await response.text();
      const responseDOM = new DOMParser().parseFromString(responseHTML, "text/html");

      const newBlogListingContainer = responseDOM.querySelector(".comp-blog-listing-item-container");

      if (newBlogListingContainer) {
        blogListingContainer.innerHTML = newBlogListingContainer.innerHTML;
      }

      endLoading();

    } catch (error) {

      if (error.name == "AbortError") {
        return;
      }

      endLoading();
      throw error;

    }
  };

  initAbortController();

  document.onkeydown = function (event) {

    switch (event.key) {
      case "ArrowLeft":
        changePage(false);
        event.preventDefault();
        break;

      case "ArrowRight":
        changePage(true);
        event.preventDefault();
        break;

      default:
        return;
    }
  };

  nextButton.addEventListener('click', (event) => {
    event.preventDefault();
    changePage(true);
  });

  previousButton.addEventListener('click', (event) => {
    event.preventDefault();
    changePage(false);
  });

  paginationLinks.forEach((link) => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      await loadPage(link as HTMLLinkElement);
    })
  })
};

register("BlogListingAjax", BlogListingAjax);
